import Status from '@src/components/Molecules/Card/Status';
import Image from 'next/image';
import styled from 'styled-components';
import pplezSvg from '@src/assets/imgs/pplezIcon.svg';
import { devices, theme } from '@src/styles/theme';
import { IBoardContent, IContent } from '@src/interfaces/community';
import Info from '@src/components/Molecules/Card/Info';
import { useRecoilValue } from 'recoil';
import keywordSelector from '@src/recoils/selector/keyword';
import Highlighter from 'react-highlight-words';
import { communintyDateFormat } from '@src/utils/date';
import CategoryImage from '@src/components/Atoms/CategoryImage';
import BloodHomeReview from '@src/components/Molecules/Card/BloodHomeReview';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

/**
 *
 * @returns 카드 내용으로써 사연,생활을 구분지어준다.
 * 23-09-14 기준 디자인이변경되서 컴포넌트 역할을 조건부로 많이 빼서 사용했다...
 * TODO: 다시 고치고싶어..
 */

type Props = {
  image: boolean;
  community: IContent | IBoardContent;
};
const Content = ({ image, community }: Props) => {
  const keywordHighLight = useRecoilValue(keywordSelector);
  const router = useRouter();
  console.log(community);
  return (
    <Container>
      {router.pathname.includes('donation') && (
        <Info community={community} isMobile={true} />
      )}

      {/* 이미지 등록했을때 */}
      {image && (
        <>
          <FlexCenter
            isMargin={true}
            isSpace={true}
            paddingValue={'12px 0 0 0'}
          >
            {router.pathname.includes('donation') && (
              <Info community={community} isMobile={false} />
            )}
            {router.pathname.includes('board') && (
              <FlexCenter isSpace={true} isBoardMobile={true}>
                <BoardWriter>
                  <Image
                    src={community?.writer?.profileImageUrl}
                    width={34}
                    height={34}
                    loader={() => community.writer.profileImageUrl}
                    alt={'프로필이미지'}
                    style={{
                      borderRadius: '50%',
                      marginRight: 14,
                    }}
                  />
                  <span>{community?.writer?.displayName}</span>
                </BoardWriter>
                <MobileWriteTime>
                  {communintyDateFormat(community?.createdAt)}
                </MobileWriteTime>
              </FlexCenter>
            )}
            {router.pathname.includes('board') && (
              <PcWriteTime>
                {communintyDateFormat(community?.createdAt)}
              </PcWriteTime>
            )}
            {router.pathname.includes('donation') && (
              <PcWriteTime>
                {communintyDateFormat(community?.lastRenewedAt)}
              </PcWriteTime>
            )}
          </FlexCenter>
          <FlexCenter isMobile={true}>
            <FlexColumn
              style={{
                flex: 2,
              }}
            >
              <div>
                {router.pathname.includes('donation') && (
                  <FlexCenter isSpace={true}>
                    <DonationWriter>
                      <span>{community?.writer?.displayName}</span>
                    </DonationWriter>
                    {community?.writer.bloodDonationCount > 0 && <OnJum />}
                    <MobileWriteTime>
                      {communintyDateFormat(community?.lastRenewedAt)}
                    </MobileWriteTime>
                  </FlexCenter>
                )}
                <div
                  style={{
                    paddingTop: router.pathname.includes('board') ? 25 : 0,
                  }}
                >
                  {router.pathname.includes('board') && (
                    <>
                      <div
                        style={{
                          marginBottom: 15,
                        }}
                      >
                        <Info community={community} isMobile={false} />
                        <Info community={community} isMobile={true} />
                      </div>
                    </>
                  )}
                  <Title>
                    <Highlighter
                      highlightStyle={{
                        backgroundColor: 'transparent',
                        color: theme.commonColor.pink004,
                      }}
                      searchWords={keywordHighLight}
                      autoEscape={true}
                      textToHighlight={community?.title}
                    >
                      {community?.title}
                    </Highlighter>
                  </Title>
                  <ContentText isImage={true}>
                    <Highlighter
                      highlightStyle={{
                        backgroundColor: 'transparent',
                        color: theme.commonColor.pink004,
                      }}
                      searchWords={keywordHighLight}
                      autoEscape={true}
                      textToHighlight={community?.content}
                    >
                      {community?.content}
                    </Highlighter>
                  </ContentText>
                </div>
                <PcBloodReviewDiv>
                  {community?.bloodHomeName !== null &&
                    router.pathname.includes('board') && (
                      <BloodHomeReview
                        name={community.bloodHomeName!}
                        address={community.bloodHomeLocation!}
                        rating={community.gpa!}
                      />
                    )}
                </PcBloodReviewDiv>
              </div>
            </FlexColumn>
            <PpleImageWrap>
              <PpleImage
                loader={() => community?.images[0]}
                src={community?.images[0]}
                alt={community?.title}
                fill={true}
              />
              {community?.images?.length > 1 && (
                <ImageCount>+{community?.images?.length - 1}</ImageCount>
              )}
            </PpleImageWrap>
            <MobileBloodReviewDiv>
              {community?.bloodHomeName !== null &&
                router.pathname.includes('board') && (
                  <BloodHomeReview
                    name={community.bloodHomeName!}
                    address={community.bloodHomeLocation!}
                    rating={community.gpa!}
                  />
                )}
            </MobileBloodReviewDiv>
          </FlexCenter>
          <Status community={community} isImage={image} />
        </>
      )}
      {/* 이미지가 없을때 */}
      {!image && (
        <>
          <FlexCenter>
            <FlexColumn2>
              <FlexCenter
                isMargin={true}
                isSpace={true}
                paddingValue={'12px 0 0 0'}
              >
                {router.pathname.includes('donation') && (
                  <Info community={community} isMobile={false} />
                )}
                {router.pathname.includes('board') && (
                  <FlexCenter isSpace={true} isBoardMobile={true}>
                    <BoardWriter>
                      {router.pathname.includes('board') && (
                        <Image
                          src={community?.writer?.profileImageUrl}
                          width={34}
                          height={34}
                          loader={() => community.writer.profileImageUrl}
                          alt={'프로필이미지'}
                          style={{
                            borderRadius: '50%',
                            marginRight: 14,
                          }}
                        />
                      )}
                      <span>{community?.writer?.displayName}</span>
                    </BoardWriter>
                    {router.pathname.includes('board') && (
                      <MobileWriteTime>
                        {communintyDateFormat(community?.createdAt)}
                      </MobileWriteTime>
                    )}
                  </FlexCenter>
                )}
                {router.pathname.includes('board') && (
                  <PcWriteTime>
                    {communintyDateFormat(community?.createdAt)}
                  </PcWriteTime>
                )}
                {router.pathname.includes('donation') && (
                  <PcWriteTime>
                    {communintyDateFormat(community?.lastRenewedAt)}
                  </PcWriteTime>
                )}
              </FlexCenter>
              <div>
                {router.pathname.includes('donation') && (
                  <FlexCenter isSpace={true}>
                    <DonationWriter>
                      <span>{community?.writer?.displayName}</span>
                      {community?.writer.bloodDonationCount > 0 && <OnJum />}
                      {community?.writer.bloodDonationCount > 0 && (
                        <BloodDonationCount>
                          헌혈인증 {community?.writer.bloodDonationCount}회
                        </BloodDonationCount>
                      )}
                    </DonationWriter>
                    <MobileWriteTime>
                      {communintyDateFormat(community?.lastRenewedAt)}
                    </MobileWriteTime>
                  </FlexCenter>
                )}
                <div
                  style={{
                    paddingTop: router.pathname.includes('board') ? 25 : 0,
                  }}
                >
                  {router.pathname.includes('board') && (
                    <>
                      <div
                        style={{
                          marginBottom: 15,
                        }}
                      >
                        <Info community={community} isMobile={false} />
                        <Info community={community} isMobile={true} />
                      </div>
                    </>
                  )}
                  <Title>
                    <Highlighter
                      highlightStyle={{
                        backgroundColor: 'transparent',
                        color: theme.commonColor.pink004,
                      }}
                      searchWords={keywordHighLight}
                      autoEscape={true}
                      textToHighlight={community?.title}
                    >
                      {community?.title}
                    </Highlighter>
                  </Title>
                  <ContentText isImage={false}>
                    <Highlighter
                      highlightStyle={{
                        backgroundColor: 'transparent',
                        color: theme.commonColor.pink004,
                      }}
                      searchWords={keywordHighLight}
                      autoEscape={true}
                      textToHighlight={community?.content}
                    >
                      {community?.content}
                    </Highlighter>
                  </ContentText>
                </div>
                <PcBloodReviewDiv>
                  {community?.bloodHomeName !== null &&
                    router.pathname.includes('board') && (
                      <BloodHomeReview
                        name={community.bloodHomeName!}
                        address={community.bloodHomeLocation!}
                        rating={community.gpa!}
                      />
                    )}
                </PcBloodReviewDiv>
              </div>
            </FlexColumn2>
          </FlexCenter>
          <MobileBloodReviewDiv>
            {community?.bloodHomeName !== null &&
              router.pathname.includes('board') && (
                <BloodHomeReview
                  name={community.bloodHomeName!}
                  address={community.bloodHomeLocation!}
                  rating={community.gpa!}
                />
              )}
          </MobileBloodReviewDiv>
          <Status community={community} isImage={image} />
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  @media ${devices.tablet} {
  }
`;

const FlexCenter = styled.div<{
  isMobile?: boolean;
  isMargin?: boolean;
  marginValue?: string;
  isSpace?: boolean;
  paddingValue?: string;
  isBoardMobile?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ isSpace }) => (isSpace ? 'space-between' : null)};
  padding: ${({ paddingValue }) => (paddingValue ? paddingValue : 0)};
  margin: ${({ isMargin, marginValue }) => (isMargin ? marginValue : 0)};
  @media ${devices.tablet} {
    ${({ isMobile }) => (isMobile ? `display: block;` : null)}
    ${({ isBoardMobile }) => (isBoardMobile ? `width: 100%;` : null)}
  }
`;

const FlexColumn = styled.div`
  height: 300px; //100% 더보기누를시
  max-height: 300px; //100% 더보기누를시
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 488px; // 자꾸 넓이가 커지는 버그가 생겨서 제한을 두었다. 23.11.14
  padding-right: 24px;
  @media ${devices.tablet} {
    margin-left: 0px;
    height: 100%;
    padding-right: 0;
    max-width: 100%;
  }
`;

const PplezIcon = styled(pplezSvg)`
  margin-right: 8px;
`;

const DonationWriter = styled.div`
  color: #979797;
  font-family: 'Regular';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 112.5% */
  letter-spacing: -0.6px;
  display: flex;
  align-items: center;
  margin: 32px 0px 24px 0px;
  @media ${devices.tablet} {
    margin: 12px 0px 8px 0px;
  }
`;
const BoardWriter = styled.div`
  color: #979797;
  font-family: 'Regular';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 112.5% */
  letter-spacing: -0.6px;
  display: flex;
  align-items: center;
  @media ${devices.tablet} {
  }
`;

const WriteTime = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.commonColor.gray004};
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const Title = styled.h4`
  font-weight: 700;
  font-size: 18px;
  color: ${({ theme }) => theme.commonColor.black};
  font-family: 'Regular';
  font-style: normal;
  line-height: 24px; /* 133.333% */
  letter-spacing: -0.6px;
  margin-bottom: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 400px;
  @media ${devices.tablet} {
    /* margin: 0px; */
  }
`;

const ContentText = styled.div<{ isImage: boolean }>`
  font-weight: 400;
  font-size: 16px;
  color: ${({ theme }) => theme.commonColor.black};
  line-height: 24px;
  letter-spacing: -0.6px;
  font-family: 'Regular';
  /* margin-top: 10px; */
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  @media ${devices.tablet} {
    /* -webkit-line-clamp: 4; */
  }
`;

const FlexColumn2 = styled.div`
  height: 300px; //100% 더보기누를시
  max-height: 300px; //100% 더보기누를시
  width: 100%;
  @media ${devices.tablet} {
    margin-left: 0px;
    height: 100%;
  }
`;

const PcWriteTime = styled.div`
  color: #b7b7b7;
  font-family: 'Regular';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  letter-spacing: -0.6px;
  display: block;
  @media ${devices.tablet} {
    margin-left: 0px;
    height: 100%;
    display: none;
  }
`;

const MobileWriteTime = styled.div`
  color: #b7b7b7;
  font-family: 'Regular';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  letter-spacing: -0.6px;
  display: none;
  @media ${devices.tablet} {
    margin-left: 0px;
    height: 100%;
    display: block;
  }
`;

const PpleImage = styled(Image)`
  border-radius: 10px;
  object-fit: cover;
  @media ${devices.tablet} {
    margin: 10px 0 8px 0;
    border-radius: 0;
  }
`;

const PcBloodReviewDiv = styled.div`
  display: block;
  margin-top: 20px;
  @media ${devices.tablet} {
    display: none;
  }
`;

const MobileBloodReviewDiv = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
  }
`;

const BloodDonationCount = styled.div`
  color: ${({ theme }) => theme.commonColor.pink004};
  font-family: 'Var';
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.48px;
`;

const OnJum = styled.div`
  background-color: ${({ theme }) => theme.commonColor.gray003};
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin: 0 8px;
`;

const PpleImageWrap = styled.div`
  width: 243px;
  height: 243px;
  position: relative;
  overflow: hidden;
  flex: 1;
  @media ${devices.tablet} {
    flex: 0;
    width: 100%;
    max-width: 100%;
  }
`;

const ImageCount = styled.div`
  position: absolute;
  border-radius: 12.775px;
  opacity: 0.6;
  background: var(--Black, #222);
  top: 5px;
  right: 5px;
  color: ${({ theme }) => theme.commonColor.white};
  font-family: 'Regular';
  font-size: 12.775px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.256px;
  padding: 6px 10px;

  @media ${devices.tablet} {
    top: 18px;
    right: 10px;
  }
`;

export default Content;
